import { TipoReajuste } from '../simulador-folha.types';
import { useState } from 'react';

interface Props {
  disabled?: boolean;
  onAplicar: (tipoReajuste: TipoReajuste, valorReajuste: number) => void;
}

export function ReajusteEmLote({ disabled, onAplicar }: Props) {
  const [tipoReajuste, setTipoReajuste] = useState<TipoReajuste>('PERCENTUAL');
  const [valor, setValor] = useState('0');

  const handleAplicar = () => {
    const numero = valor === '' ? 0 : Number(valor);
    if (Number.isNaN(numero) || numero < 0) return;
    onAplicar(tipoReajuste, numero);
  };

  return (
    <>
      <div className="col-md-3 col-lg-2">
        <label htmlFor="reajuste-lote-tipo" className="form-label">Tipo (todas)</label>
        <select
          id="reajuste-lote-tipo"
          className="form-select form-select-sm"
          value={tipoReajuste}
          disabled={disabled}
          onChange={(e) => setTipoReajuste(e.target.value as TipoReajuste)}
        >
          <option value="PERCENTUAL">Percentual (%)</option>
          <option value="VALOR_FIXO">Valor fixo (R$)</option>
        </select>
      </div>
      <div className="col-md-2 col-lg-2">
        <label htmlFor="reajuste-lote-valor" className="form-label">Valor (todas)</label>
        <input
          id="reajuste-lote-valor"
          type="number"
          min="0"
          step="0.01"
          className="form-control form-control-sm"
          value={valor}
          disabled={disabled}
          onChange={(e) => setValor(e.target.value)}
        />
      </div>
      <div className="col-md-3 col-lg-2">
        <label className="form-label d-none d-md-block">&nbsp;</label>
        <button
          type="button"
          className="btn btn-sm btn-outline-primary w-100"
          disabled={disabled}
          onClick={handleAplicar}
        >
          Aplicar a todas
        </button>
      </div>
    </>
  );
}
